import React from 'react';
import close from '../../../assets/images/model/close.svg';
import butterfly from '../../../assets/images/model/butterfly.svg';
import infoCreate from '../../../assets/images/model/info-create.svg';
import polygonArrow from '../../../assets/images/model/Polygon-dowan-arrow.svg';

const UploadedImage = ({ setUploadedImag, setSelectedUploadingImag }) => {
  return (
    <div>
      <div className='modal custom_background custom_modal_create' id='upload_book' style={{ display: 'block' }} tabIndex='-1' aria-labelledby='upload_bookLabel' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button
                onClick={() => {
                  setUploadedImag(false);
                  setSelectedUploadingImag(false);
                }}
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <img src={close} alt='close' />
              </button>
            </div>
            <div className='modal-body-cre'>
              <h4>add image</h4>
              <div className='add_img_cre'>
                <img src={butterfly} alt='Image' />
                <form action='' className='pick_from_library'>
                  <div className='pick_from_library_filter_wrap'>
                    <div className='pick_from_library_filter my-40 mt-20'>
                      <div className='icon'>
                        <div className='tooltip_wrap'>
                          <h2 className='icon_h2 mb-0'>
                            Alt. text <img src={infoCreate} className='info_tooltip' alt='Info' />
                          </h2>
                          <p>
                            Describes images for people who have trouble seeing them <img src={polygonArrow} alt='Polygo' />
                          </p>
                        </div>
                        <input type='text' className='pick_from_input_cre border_color' placeholder='Write a detailed description of the image' />

                        <div className='tooltip_wrap Attribution'>
                          <h2 className='icon_h2 mb-0'>
                            Attribution <img src={infoCreate} className='info_tooltip' alt='Info' />
                          </h2>
                          <p>
                            Provide the source of the image to give creator credit <img src={polygonArrow} alt='Polygo' />
                          </p>
                        </div>
                        <input style={{ height: '60px' }} type='text' className='pick_from_input_cre border_color' placeholder='Paste the link...' />
                      </div>
                    </div>
                  </div>
                  <div className='modal-btn'>
                    <button
                      type='button'
                      className='btn-black_create'
                      onClick={() => {
                        setUploadedImag(false);
                        setSelectedUploadingImag(false);
                      }}
                    >
                      Done
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadedImage;
